package ir.hosen.resume.util

enum class FooterLinks(val icon: String, val url: String) {
    LINKEDIN(icon = "/linkedin.svg", url = "https://linkedin.com/in/hossein-panahandeh-314bb1163/"),
    GITHUB(icon = "/github.svg", url = "https://github.com/hossein-no1/"),
    X(icon = "/x.svg", url = "https://x.com/hosen_no1/"),
    MEDIUM(icon = "/medium.svg", url = "https://medium.com/@hosen.no1/"),
}